import { useQuery } from "hooks/useQuery";
import { getPlans } from "../service";

export const usePlans = () => {
  const { isLoading, data } = useQuery({
    queryKey: ["plans"],
    queryFn: async () => {
      const response = await getPlans({ label: "display_on_app" });
      return response;
    },
  });

  return {
    isLoading,
    plans: data || {},
  };
};
